export default __webpack_public_path__ + "static/media/menu_icon.52138a9b.svg";